import { render } from "./menuManage.vue?vue&type=template&id=6678ac36&scoped=true"
import script from "./menuManage.vue?vue&type=script&lang=js"
export * from "./menuManage.vue?vue&type=script&lang=js"

import "./menuManage.vue?vue&type=style&index=0&id=6678ac36&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6678ac36"]])

export default __exports__